module.exports = __webpack_public_path__ + "media/images/brand/logo-09-564542c6aac17f7f14a47a33448eac7b.png";